export default __webpack_public_path__ + "static/workflows-7f8d089fdcef390a2ca564e1bc0e7c90.png";